// extracted by mini-css-extract-plugin
export default {"loadingPage":"Loading_loadingPage__joFnX"};